import { parseSiteTimestamp, formatSiteTime } from '@/lib/userTime'

// Compact relative-time formatter for notification rows. Hand-written on
// purpose — date-fns is intentionally NOT a dependency of this app. Mirrors
// the defensive NaN guard used by ThreadView.tsx's formatSentOn.
//
// BUG FIXED 2026-07-28: this used `new Date(iso)`, but the API sends Eastern
// wall-clock with NO offset, so the browser parsed it as the VIEWER's local
// time. Every non-Eastern reader got a skewed age — a Pacific user saw "just
// now" on anything up to 3 hours old, a European user saw ages inflated by
// 5-6 hours. `parseSiteTimestamp` interprets the string as Eastern, which is
// what it has always been.
//
// The relative text itself needs no zone (an elapsed duration is the same
// everywhere); only the absolute fallback below does.
export function formatRelative(
  iso: string | null | undefined,
  timeZone: string = '',
): string {
  if (!iso) return ''
  const parsed = parseSiteTimestamp(iso)
  if (!parsed) return ''
  const then = parsed.getTime()

  const seconds = Math.round((Date.now() - then) / 1000)
  if (seconds < 60) return 'just now'

  const minutes = Math.round(seconds / 60)
  if (minutes < 60) return `${minutes}m ago`

  const hours = Math.round(minutes / 60)
  if (hours < 24) return `${hours}h ago`

  const days = Math.round(hours / 24)
  if (days < 7) return `${days}d ago`

  const weeks = Math.round(days / 7)
  if (weeks < 5) return `${weeks}w ago`

  // Older than ~a month: an absolute date is clearer than "9w ago". This one
  // IS zone-sensitive, so it goes through the viewer's zone.
  return formatSiteTime(parsed, timeZone, { time: false })
}
